import btc from "../../Assests/bitcon.png";
import eth from "../../Assests/ethereum.png";
import ltc from "../../Assests/litecoin.png";

export const CryptoData = [
  {
    id: 1,
    title: "Bitcoin",
    symbol: "BTC",
    image: btc,
    description:
      "Digital currency in which a record of transactions is maintained.",
  },
  {
    id: 2,
    title: "Ethereum",
    symbol: "ETH",
    description:
      "Blockchain technology to create and run decentralized digital applications.",
    image: eth,
  },
  {
    id: 3,
    title: "Litecoin",
    symbol: "LTC",
    description:
      "Cryptocurrency that enables instant payments to anyone in the world.",
    image: ltc,
  },
];
